// extracted by mini-css-extract-plugin
module.exports = {"additionalInfosList":"style_additionalInfosList__hqhS9","selectedType":"style_selectedType__34EEe","options":"style_options__3N9LT","option":"style_option__3jDZ0"};